import { render, staticRenderFns } from "./HouseholdDivisionChart.vue?vue&type=template&id=f5319b52&scoped=true&"
import script from "./HouseholdDivisionChart.vue?vue&type=script&lang=js&"
export * from "./HouseholdDivisionChart.vue?vue&type=script&lang=js&"
import style0 from "./HouseholdDivisionChart.vue?vue&type=style&index=0&id=f5319b52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5319b52",
  null
  
)

export default component.exports